<template>
    <span @click="onClick" class="kl-icon" style="display: inline-block;" :class="{ border: border }"><i class="iconfont" :class="icon"
            :style="{ 'font-size': size + 'px' }"></i> </span>
</template>
<script>
export default {
    props: {
        icon: {
            type: String,
            default: ""
        },
        size: {
            type: Number,
            default: 20
        },
        border: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        onClick(){
            this.$emit("click");
        }
    }
}
</script>
<style scoped>
.border {
    border: 1px solid #D9E4F8;
    border-radius: 2px;
    padding: 3px;
}
</style>